import $ from 'jquery';
window.$ = window.jQuery = $;

import 'popper.js';
import 'bootstrap';
import 'slick-carousel';

import 'aos/dist/aos.css';
import AOS from 'aos';

import '../scss/style.scss';

import './menu.js';
import './carousel.js';
import './scrollToElement.js';
import './home.js';
import './jobOffers.js';
import './scrollToTop.js';
import initPageGallery from './pageGallery.js';

import counterUp from 'counterup2';

// --- Compteurs (counterup2 via IntersectionObserver) ---
const countersObserver = new IntersectionObserver((entries, obs) => {
  entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    const el = entry.target;
    counterUp(el, { duration: 800, delay: 16 });
    obs.unobserve(el);
  });
}, { threshold: 0.2 });

// --- Helpers ---
function initAOSWhenReady() {
  if (!($('#homepage').length || $('#page').length)) return;

  if ($('.go-to-element').length) {
    $(document).one('goToElement:done', function () {
      AOS.init();
      setTimeout(() => {
        AOS.refreshHard();
      }, 100);
    });
  } else {
    AOS.init();
    setTimeout(() => {
      AOS.refreshHard();
    }, 100);
  }
}

// --- Initialisation app ---
$(function () {
  if ($('#message').length) $('#message').modal('show');

  document.querySelectorAll('.counter, [data-counter]').forEach(el => {
    countersObserver.observe(el);
  });

  initAOSWhenReady();
  initPageGallery();
});